import React from "react";
import PageLayout from "../../../components/Layout/PageLayout";
import ResponsibleAICommitment from "./misc/ResponsibleAICommitment";

const ResponsibleAI: React.FC = () => {
  return (
    <PageLayout>
      <ResponsibleAICommitment />
    </PageLayout>
  );
};

export default ResponsibleAI;
